/**
 * PURE. Display names (creatures §A11.1, §A12.3; GDD C83): `[Title] Name [Epithet]` from the identity bits, or the custom
 * name carried by the share-string suffix. Russian pools live in `src/content/strings/ru/constructor.ts`.
 */
import { NAME_POOL } from '../../content/creature/parts';
import { constructorStrings as S } from '../../content/strings/ru/constructor';

const CUSTOM_RE = /^[А-Яа-яЁёA-Za-z]+([ -][А-Яа-яЁёA-Za-z]+)?$/;

/** Validates a custom name (2–16 letters, one internal space or hyphen; NFC). Returns the normalized name or null. */
export function validateCustomName(raw: string): string | null {
  const s = raw.normalize('NFC').trim();
  if (s.length < 2 || s.length > 16) return null;
  return CUSTOM_RE.test(s) ? s : null;
}

/** Generated name from the identity bits. */
export function generatedName(title: number, name: number, epithet: number, pronoun: 0 | 1): string {
  const g = pronoun ? 'f' : 'm';
  const t = S[`constructor.title.${title % NAME_POOL.titles}.${g}`] ?? '';
  const n = S[`constructor.name.${name % NAME_POOL.names}`] ?? '';
  const e = S[`constructor.epithet.${epithet % NAME_POOL.epithets}.${g}`] ?? '';
  return [t, n, e].filter(Boolean).join(' ');
}

/** Index range of the name pool for a pronoun (ghosts pick a name that matches it). */
export const namePoolFor = (pronoun: 0 | 1): [number, number] => (pronoun ? [NAME_POOL.namesMasc, NAME_POOL.names - 1] : [0, NAME_POOL.namesMasc - 1]);
